import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

const SORT_FIELD_MAP = {
  goal_title: "title",
  goal_region: "region",
  goal_club: "club",
  rikognition_status: "rikognition_status",
};

export const fetchGoalData =
  (token, search, page, sort, order, status = "") => async (dispatch) => {
    dispatch({ type: "FETCH_GOAL_REQUEST" });

    let reqQuery = `?page=${page}&search=${encodeURIComponent(search || "")}`;
    if (sort) {
      const sortField = SORT_FIELD_MAP[sort] || sort;
      reqQuery += `&sort=${sortField}&order=${order}`;
    }
    if (status) {
      reqQuery += `&status=${encodeURIComponent(status)}`;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getAllGoals${reqQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: "FETCH_GOAL_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "FETCH_GOAL_FAILURE", payload: error.message });
    }
  };
